// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import {combineReducers} from 'redux';
import {ActionTypes} from 'utils/constants.jsx';

function draft(state={}, action) {
    switch (action.type) {
    case ActionTypes.SET_PRESENCE_DRAFT:
         return action.state;
    default:
        return state;
    }
}

function draftMode(state=false, action) {
    switch (action.type) {
    case ActionTypes.SET_PRESENCE_DRAFT_MODE:
         return action.state;
    default:
        return state;
    }
}

function getPresenceUsersRequest(state = false, action) {
    switch (action.type) {
        case ActionTypes.GET_PRESENCE_USERS_REQUEST_STATUS:
            return action.state;
        default:
            return state;
    }
}


export default combineReducers({
    draft,
    draftMode,
    getPresenceUsersRequest,
});
